import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsOutputHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Output;
    }
}

//# sourceMappingURL=IsOutputHelper.js.map
